

import { computed, ref, shallowRef, watch } from 'vue'
import moment from 'moment';
import {FilterMatchMode, FilterOperator} from "primevue/api";
import router from "@/router";
import {useToast} from "primevue/usetoast";
import {useStore} from "vuex";
import {RegisterService} from "@/models/registerService";
import {useRouter} from "vue-router";
import benhNhanRepository from "@/services/BenhNhanRepository";
import {NhanVienVltl} from "@/models/NhanVienVltl";
import {DichVu} from "@/models/dichVu";
import {NhomThucHienDichVu} from "@/models/nhomThucHienDichVu";
import {KhoaPhong} from "@/models/khoaPhong";
import {NhanVienKhoaPhong} from "@/models/nhanVienKhoaPhong";
import {NhanVienThucHien} from "@/models/nhanVienThucHien";
import {ThietBi} from "@/models/thietBi";
import type {ThietBiHis} from "@/models/thietBiHis";
import {NhomThietBi} from "@/models/nhomThietBi";
import {CaiDatChiTietThucHienDichVu} from "@/models/caiDatChiTietThucHienDichVu";
import axios from "axios";
import {CaiDatChiTietThucHienDichVuUpdate} from "@/models/caiDatChiTietThucHienDichVuUpdate";
import { useConfirm } from "primevue/useconfirm";
import {NguoiThucHien} from "@/models/nguoiThucHien";
import {ThietBiDichVu} from "@/models/thietBiDichVu";
import {NhanVienHoatDong} from "@/models/nhanVienHoatDong";
import {KetQuaChiaGio} from "@/models/ketQuaChiaGio";
import {ChamCongNhanVien} from "@/models/chamCongNhanVien";
import {DongDichVu, gomDichVu} from "@/utils/nhomDichVu";
import BangChon from '@/components/BangChon.vue';
import {useDichVuKhoa} from '@/composables/useDichVuKhoa';
import KhungChiTiet from '@/components/KhungChiTiet.vue';
import NhomDichVuNoiBo from '@/components/NhomDichVuNoiBo.vue';
import LichSuChiaGio from '@/components/LichSuChiaGio.vue';
import BangLichNhanVien from '@/components/BangLichNhanVien.vue';


export default {
  components: {BangChon, KhungChiTiet, NhomDichVuNoiBo,LichSuChiaGio,BangLichNhanVien},
  setup() {
    const confirm = useConfirm();
    const toast = useToast();
    const store = useStore();
    const date = ref();
    const service = ref("");
    const router = useRouter();
    const kind = ref(0);
    // Danh mục HIS có hơn 2.500 phần tử; shallowRef tránh Vue tạo proxy sâu
    // cho toàn bộ danh sách trong khi bảng chỉ hiển thị một trang nhỏ.
    const listDichVuAll = shallowRef([] as DichVu[]);
    const khoaLamViec = ref(0);
    const buocDangMo = ref(0);
    const nhomDichVuNoiBoRef = ref();
    const {listDichVu, dangTaiDichVuKhoa, taiDichVuKhoa} = useDichVuKhoa(khoaLamViec);
    const dichVu = ref({} as DichVu);
    dichVu.value.soThucHien = 1;
    dichVu.value.thoiGianNghi = 0;
    const listNhomDichVu = ref([] as {nhomDichVu_Id: number; tenNhomDichVu: string}[]);
    const nhomDichVuSelect = ref(0);
    const listDichVuTheoNhom = shallowRef([] as DichVu[]);
    const dichVuDaChon = ref([] as DichVu[]);
    const chonTatCaDichVu = ref(false);
    const dangLuuDichVu = ref(false);
    const nhomDichVuDangMo = ref([] as number[]);
    const soDichVuDaChon = computed(() => chonTatCaDichVu.value ? listDichVuTheoNhom.value.length : dichVuDaChon.value.length);
    const dongChonTatCa = computed(() => [{
      tenDichVu: `Tất cả dịch vụ — ${listNhomDichVu.value.find(x => x.nhomDichVu_Id === nhomDichVuSelect.value)?.tenNhomDichVu || ''}`,
      soLuong: listDichVuTheoNhom.value.length
    }]);
    const bangDichVu = computed(() => gomDichVu(listDichVu.value, listDichVuAll.value, nhomDichVuDangMo.value));
    const moNhomDichVu = (id: number) => {
      nhomDichVuDangMo.value = [...nhomDichVuDangMo.value, id];
    };
    const boLocDichVuChon = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });
    const listNhomThucHienDV = ref([] as NhomThucHienDichVu[]);
    const listNhanVienVltl = ref([] as NhanVienVltl[]);
    const nhomThucHien = ref({} as NhomThucHienDichVu);
    const showScreenChoice = ref(false);
    const idNhanVien = ref(0);
    const listKhoaPhong = ref([] as KhoaPhong[]);
    const tenKhoaLamViec = computed(() => listKhoaPhong.value.find(x => x.phongBan_Id === khoaLamViec.value)?.tenPhongBan || '');
    const nhanVienKhoaPhong = ref({} as NhanVienKhoaPhong);
    const nhanVienKhoaIds = ref([] as number[]);
    const chinhNhanVienIds = ref([] as number[]);
    const phuNhanVienIds = ref([] as number[]);
    const chinhDichVuIds = ref([] as number[]);
    const phuDichVuIds = ref([] as number[]);
    const thietBiCauHinhIds = ref([] as number[]);
    const thietBiDichVuIds = ref([] as number[]);
    const apCaNhomThietBi = ref(true);
    const nhomThietBiDaGan = ref([] as any[]);
    const dangLuuCauHinh = ref(false);
    const listNhanVienKhoaPhong = ref([] as NhanVienKhoaPhong[]);
    const idKhoaPhong = ref(0);
    const idNhanVienSelect = ref(0);
    const idNhomThucHienDV = ref(0);
    const listNhanVienKhoaPhongById = ref([] as NhanVienKhoaPhong[]);
    const listNhanVienKhoaPhongByIdChinh = ref([] as NhanVienKhoaPhong[]);
    const listNhanVienKhoaPhongByIdPhu = ref([] as NhanVienKhoaPhong[]);
    const nhanVienThucHienChinh = ref({} as NhanVienThucHien);
    const nhanVienThucHienPhu = ref({} as NhanVienThucHien);
    const listNhanVienThucHien = ref([] as NhanVienThucHien[]);
    const listNhanVienThucHienChinh = ref([] as NhanVienThucHien[]);
    const listNhanVienThucHienPhu = ref([] as NhanVienThucHien[]);
    const listThietBi = ref([] as ThietBi[]);
    const thietBi = ref({} as ThietBi);
    const danhMucThietBi = shallowRef([] as ThietBiHis[]);
    const thietBiTrongKhoa = ref([] as ThietBi[]);
    const thietBiDaChon = ref([] as ThietBiHis[]);
    const dangTaiDanhMucThietBi = ref(false);
    const dangTaiThietBiKhoa = ref(false);
    const dangGanThietBi = ref(false);
    const boLocThietBiHis = ref({global: {value: null, matchMode: FilterMatchMode.CONTAINS}});
    const thietBiChuaGan = computed(() => {
      const daGan = new Set(thietBiTrongKhoa.value.map(x => x.thietBiHisId));
      return danhMucThietBi.value.filter(x => !daGan.has(x.thietBi_Id));
    });
    const listNhomThietBi = ref([] as NhomThietBi[]);
    const nhomThietBi = ref({} as NhomThietBi);
    const caiDatChiDinhDV = ref({} as CaiDatChiTietThucHienDichVu);
    const listCaiDatDV = ref([] as CaiDatChiTietThucHienDichVu[]);
    const loadingData = ref(false);
    const idKhoaPhongSelect = ref(0);
    const idKhoaPhongChinh = ref(0);
    const idKhoaPhongPhu = ref(0);
    const idNhomThietBi = ref(0);
    const idKhoaPhongThietBi = ref(0);
    const nguoiThucHienChinh = ref({} as NguoiThucHien);
    const nguoiThucHienPhu = ref({} as NguoiThucHien);
    const listNguoiThucHienChinh = ref([] as NguoiThucHien[]);
    const listNguoiThucHienPhu = ref([] as NguoiThucHien[]);
    const listThietBiTheoKhoa = ref([] as ThietBi[]);
    const thietBiDichVu = ref({} as ThietBiDichVu);
    const listThietBiDichVu = ref([] as ThietBiDichVu[]);
    const isLoggedIn = computed(() => !!store.state.token);
    const nhanVienHoatDong = ref([] as NhanVienHoatDong[]);
    const ketQuaChiaGio = ref(null as KetQuaChiaGio | null);
    const hienLichNhanVien=ref(false),hienLichSu=ref(false);
    const soNhanVienTrongLich=computed(()=>{
      const result=ketQuaChiaGio.value;if(!result)return 0;
      const ids=new Set((result.nhanViens||[]).map(x=>x.nhanVien_Id));
      result.daXepLich.forEach(x=>{ids.add(x.nhanVienId);if(x.nhanVienPhuId!=null)ids.add(x.nhanVienPhuId);});return ids.size;
    });
    const lichSuRef=ref();
    const phienLichSu=ref(0);
    const thoiGianUtc=(s:string)=>s?moment.utc(s).local().format('DD/MM/YYYY HH:mm:ss'):'';
    const ngayLichSuDangXem=computed(()=>ketQuaChiaGio.value?moment(ketQuaChiaGio.value.ngayThucHien).format('DD/MM/YYYY'):'');
    const moLichSuChiaGio=(result:KetQuaChiaGio)=>{
      if(result.khoaPhongId!==khoaLamViec.value)return;
      ketQuaChiaGio.value=result;benhNhanDangXem.value='';hienLichDaXep.value=false;hienTongHopBenhNhan.value=false;hienLichChuaXep.value=false;hienLichNhanVien.value=false;
    };
    const benhNhanDangXem = ref('');
    const hienTongHopBenhNhan = ref(false);
    const hienLichDaXep = ref(false);
    const hienLichChuaXep = ref(false);
    const dangXuatExcel = ref(false);
    const xemDichVuBenhNhan = (key: string) => {
      benhNhanDangXem.value=key;
      hienLichDaXep.value=true;
      hienLichChuaXep.value=true;
    };
    const lichDangXem = computed(() => (ketQuaChiaGio.value?.daXepLich || []).filter(x => !benhNhanDangXem.value || x.khoaBenhNhan === benhNhanDangXem.value));
    const chuaXepDangXem = computed(() => (ketQuaChiaGio.value?.chuaXepLich || []).filter(x => !benhNhanDangXem.value || x.khoaBenhNhan === benhNhanDangXem.value));
    const danhSachChamCong = ref([] as ChamCongNhanVien[]);
    const chamCongDaLuu = ref(false);
    const loadingChamCong = ref(false);

    let phienPhanCong = 0;
    const getListNguoiThucHien = async (_id = 0, _vt = 0) => {
      const khoa = khoaLamViec.value;
      const phien = ++phienPhanCong;
      if (!khoa) return;
      try {
        const response = await benhNhanRepository.getPhanCongNhanVien(khoa);
        if (khoa !== khoaLamViec.value || phien !== phienPhanCong) return;
        const chinh = nguoiThucHienChinh.value.idNguoiThucHien;
        const phu = nguoiThucHienPhu.value.idNguoiThucHien;
        listNguoiThucHienChinh.value = response.data.filter(x => x.vaiTro === 1 && (!chinh || x.idNguoiThucHien === chinh));
        listNguoiThucHienPhu.value = response.data.filter(x => x.vaiTro === 2 && (!phu || x.idNguoiThucHien === phu));
        return response.data;
      } catch (err) {
        if (khoa === khoaLamViec.value && phien === phienPhanCong)
          toast.add({severity:'error', summary:'Không tải được phân công đã lưu', detail:err.response?.data || 'Vui lòng thử lại', life:3500});
      }
    };

    const getListThietBiDichVu = () => {
      benhNhanRepository.getListThietBiDichVu(thietBiDichVu.value.idDichVu, thietBiDichVu.value.idKhoaPhong)
          .then((response) => {
            listThietBiDichVu.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail: err.response.data,
              life: 2500
            })
          });
    }

    

    const deleteThietBiDichVu = (id: number) => {
      confirm.require({
        group: 'templating',
        header: 'Xóa thiết bị ra khỏi danh sách',
        message: 'Xác nhận xóa thiết bị ra khỏi danh sách',
        icon: 'pi pi-exclamation-circle',
        acceptLabel: 'Xóa',
        rejectLabel: 'Hủy',
        accept: () => {
          // toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
          benhNhanRepository.deleteThietBiDichvu(id,khoaLamViec.value)
              .then((response) => {
                getListThietBiDichVu();
                toast.add({
                  severity: 'info',
                  summary: 'Thành công',
                  detail: 'Xóa thiết bị thành công',
                  life: 2500
                })
              })
              .catch(err => {
                toast.add({
                  severity: 'error',
                  summary: 'Lỗi',
                  detail:err.response.data,
                  life: 2500
                })});
        },
        reject: () => {
          // toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        }
      })
    }

    

    const selectKhoaPhong = (id, vt) => {
      if (vt === 1) { chinhNhanVienIds.value = []; listNhanVienKhoaPhongByIdChinh.value = []; listNguoiThucHienChinh.value = []; }
      else { phuNhanVienIds.value = []; listNhanVienKhoaPhongByIdPhu.value = []; listNguoiThucHienPhu.value = []; }
      benhNhanRepository.getListNhanVienByIdKhoaPhong(id)
          .then((response) => {
            if (id !== (vt === 1 ? idKhoaPhongChinh.value : idKhoaPhongPhu.value)) return;
            if(vt == 1) {
              listNhanVienKhoaPhongByIdChinh.value = response.data;
            }
            else{
              listNhanVienKhoaPhongByIdPhu.value = response.data;
            }
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    }

    const deleteDichVuThucHien = (id: number, vt) => {
      confirm.require({
        group: 'templating',
        header: 'Xóa dịch vụ ra khỏi danh sách',
        message: 'Xác nhận xóa dịch vụ ra khỏi danh sách',
        icon: 'pi pi-exclamation-circle',
        acceptLabel: 'Xóa',
        rejectLabel: 'Hủy',
        accept: () => {
          // toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
          benhNhanRepository.deleteDichVuThucHienById(id,khoaLamViec.value)
              .then((response) => {
                if(vt == 1) {
                  getListNguoiThucHien(nguoiThucHienChinh.value.idNguoiThucHien, 1);
                }
                else{
                  getListNguoiThucHien(nguoiThucHienPhu.value.idNguoiThucHien, 2);
                }
                toast.add({
                  severity: 'info',
                  summary: 'Thành công',
                  detail: 'Xóa dịch vụ thành công',
                  life: 2500
                })
              })
              .catch(err => {
                toast.add({
                  severity: 'error',
                  summary: 'Lỗi',
                  detail:err.response.data,
                  life: 2500
                })});
        },
        reject: () => {
          // toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        }
      })
    }


    

    

    const dangTaiDanhMucDuyet = ref(false);
    const taiDanhMucDuyet = async () => {
      if (!khoaLamViec.value || listDichVuAll.value.length || dangTaiDanhMucDuyet.value) return;
      dangTaiDanhMucDuyet.value = true;
      try {
        listDichVuAll.value = (await benhNhanRepository.dsCDAll()).data;
        const nhom = new Map<number, string>();
        listDichVuAll.value.forEach(x => nhom.set(x.nhomDichVu_Id, x.tenNhomDichVu));
        listNhomDichVu.value = Array.from(nhom.entries())
          .map(x => ({nhomDichVu_Id:x[0], tenNhomDichVu:x[1]}))
          .sort((a,b) => a.tenNhomDichVu.localeCompare(b.tenNhomDichVu));
      } catch (err) {
        toast.add({severity:'error', summary:'Không tải được danh mục để duyệt', detail:err.response?.data || 'Vui lòng thử lại', life:3500});
      } finally { dangTaiDanhMucDuyet.value = false; }
    };

    const getListDV = async () => {
      try {
        const [staff, nhom, khoa] = await Promise.all([
          benhNhanRepository.getListNhanVienVltl(), benhNhanRepository.getListNhom(), benhNhanRepository.getListKhoaPhong()
        ]);
        listNhanVienVltl.value = staff.data.map(x => ({...x, userName:x.userName + ' - ' + x.userCode}));
        listNhomThucHienDV.value = nhom.data;
        listKhoaPhong.value = khoa.data;
      } catch (err) {
        toast.add({severity:'error', summary:'Không tải được dữ liệu cấu hình', detail:err.response?.data || 'Vui lòng thử lại', life:3500});
      }
    };

    getListDV();

    const locDichVuTheoNhom = () => {
      const daCauHinh = new Set(listDichVu.value.map(x => x.dichVu_Id));
      listDichVuTheoNhom.value = listDichVuAll.value.filter(x =>
        x.nhomDichVu_Id === nhomDichVuSelect.value && !daCauHinh.has(x.dichVu_Id));
      dichVuDaChon.value = [];
      chonTatCaDichVu.value = false;
      boLocDichVuChon.value.global.value = null;
    }

    const chonCaNhom = () => {
      // Chế độ All chỉ giữ ID nhóm, không tạo hàng trăm phần tử selection reactive.
      dichVuDaChon.value = [];
    }

    const boChonTatCa = () => {
      chonTatCaDichVu.value = false;
      dichVuDaChon.value = [];
    }

    const createNhieuDichVu = () => {
      if (dangLuuDichVu.value || !soDichVuDaChon.value || !khoaLamViec.value) return;
      if (!Number.isInteger(dichVu.value.soThucHien) || dichVu.value.soThucHien < 1 ||
          !Number.isInteger(dichVu.value.thoiGianNghi) || dichVu.value.thoiGianNghi < 0) {
        toast.add({severity: 'warn', summary: 'Cấu hình chưa hợp lệ', detail: 'Nhập số thực hiện lớn hơn 0 và thời gian nghỉ từ 0 phút.', life: 3000});
        return;
      }
      dangLuuDichVu.value = true;
      const danhSach = dichVuDaChon.value.map(x => ({...x,
        soThucHien: dichVu.value.soThucHien || 1,
        thoiGianNghi: dichVu.value.thoiGianNghi || 0
      }));
      const request = benhNhanRepository.duyetDichVuKhoa({
        idKhoaPhong:khoaLamViec.value, dichVuIds:danhSach.map(x => x.dichVu_Id),
        chonCaNhom:chonTatCaDichVu.value, nhomDichVuId:nhomDichVuSelect.value,
        soThucHien:dichVu.value.soThucHien, thoiGianNghi:dichVu.value.thoiGianNghi
      });
      request
        .then(response => {
          toast.add({severity: 'success', summary: 'Đã thêm dịch vụ',
            detail: `Đã duyệt ${response.data.soDaThem} dịch vụ cho ${tenKhoaLamViec.value}`, life: 2500});
          dichVuDaChon.value = [];
          return taiDichVuKhoa();
        })
        .then(() => {
          locDichVuTheoNhom();
        })
        .catch(err => toast.add({severity: 'error', summary: 'Lỗi', detail: err.response && err.response.data ? err.response.data : 'Không thêm được dịch vụ', life: 3000}))
        .finally(() => dangLuuDichVu.value = false);
    }

    const updateDichVu = (item: DongDichVu) => {
      if (dangLuuDichVu.value) return;
      if (item.soThucHien == null || item.thoiGianNghi == null || item.soThucHien < 1 || item.thoiGianNghi < 0) {
        toast.add({severity: 'warn', summary: 'Cấu hình khác nhau', detail: 'Nhập đủ số thực hiện và thời gian nghỉ chung, hoặc xem chi tiết để sửa từng dịch vụ.', life: 3500});
        return;
      }
      dangLuuDichVu.value = true;
      const ids = item.laCaNhom ? listDichVu.value.filter(x => x.nhomDichVu_Id === item.nhomDichVu_Id).map(x => x.dichVu_Id) : [item.dichVu_Id];
      const request = benhNhanRepository.suaDichVuKhoa({idKhoaPhong:khoaLamViec.value, dichVuIds:ids,
        soThucHien:item.soThucHien, thoiGianNghi:item.thoiGianNghi});
      request
        .then(() => taiDichVuKhoa())
        .then(() => {
          toast.add({severity: 'success', summary: 'Đã lưu', detail: `Đã cập nhật ${item.tenDichVu}`, life: 1800});
        })
        .catch(err => toast.add({severity: 'error', summary: 'Lỗi', detail: err.response && err.response.data ? err.response.data : 'Không cập nhật được dịch vụ', life: 3000}))
        .finally(() => dangLuuDichVu.value = false);
    }

    const createNhomDichVu = () => {
      benhNhanRepository.createNhomThucHienDV(nhomThucHien.value)
          .then((response) => {
            benhNhanRepository.getListNhom()
                .then((response) => {
                  listNhomThucHienDV.value = response.data;
                  console.log("@@@@@@@@@################ listDichVu list: " + JSON.stringify(listDichVu.value));
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail:err.response.data,
                    life: 2500
                  })});
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    }

    

    const themNhanVienHangLoat = async () => {
      if (dangLuuCauHinh.value || !nhanVienKhoaPhong.value.idKhoaPhong || !nhanVienKhoaIds.value.length) return;
      dangLuuCauHinh.value = true;
      try {
        const response = await benhNhanRepository.cauHinhHangLoat('nhanVienKhoa', {
          idKhoaPhong: nhanVienKhoaPhong.value.idKhoaPhong, nhanVienIds: nhanVienKhoaIds.value
        });
        listNhanVienKhoaPhong.value = (await benhNhanRepository.getListNhanVienByIdKhoaPhong(khoaLamViec.value)).data;
        listNhanVienKhoaPhongByIdChinh.value = listNhanVienKhoaPhong.value;
        listNhanVienKhoaPhongByIdPhu.value = listNhanVienKhoaPhong.value;
        listNhanVienKhoaPhong.value.forEach(x => x.khoaPhong = listKhoaPhong.value.find(y => y.phongBan_Id === x.idKhoaPhong)?.tenPhongBan || '');
        nhanVienKhoaIds.value = [];
        toast.add({severity:'success', summary:'Đã lưu', detail:`Đã thêm ${response.data.soDaThem} nhân viên mới`, life:2500});
      } catch (err) {
        toast.add({severity:'error', summary:'Không lưu được', detail:err.response?.data || 'Không thêm được nhân viên', life:3500});
      } finally { dangLuuCauHinh.value = false; }
    };

    const ganNhanVienHangLoat = async (vaiTro: number) => {
      if (dangLuuCauHinh.value) return;
      const nvIds = [...(vaiTro === 1 ? chinhNhanVienIds.value : phuNhanVienIds.value)];
      const dvIds = [...(vaiTro === 1 ? chinhDichVuIds.value : phuDichVuIds.value)];
      const khoa = vaiTro === 1 ? idKhoaPhongChinh.value : idKhoaPhongPhu.value;
      if (!khoa || !nvIds.length || !dvIds.length) return;
      dangLuuCauHinh.value = true;
      try {
        const response = await benhNhanRepository.cauHinhHangLoat('nhanVienDichVu', {
          idKhoaPhong:khoa, vaiTro, nhanVienIds:nvIds, dichVuIds:dvIds
        });
        if (khoa !== khoaLamViec.value) return;
        if (vaiTro === 1) {
          nguoiThucHienChinh.value.idNguoiThucHien = nvIds[0];
        } else {
          nguoiThucHienPhu.value.idNguoiThucHien = nvIds[0];
        }
        const saved = await getListNguoiThucHien();
        if (khoa !== khoaLamViec.value) return;
        const pairs = new Set((saved || []).filter(x => x.idKhoaPhong === khoa && x.vaiTro === vaiTro)
            .map(x => `${x.idNguoiThucHien}:${x.idDichVu}`));
        if (!nvIds.every(nv => dvIds.every(dv => pairs.has(`${nv}:${dv}`))))
          throw new Error('Chưa xác nhận được đầy đủ phân công đã lưu. Vui lòng tải lại bảng để kiểm tra trước khi chia giờ.');
        ketQuaChiaGio.value = null;
        toast.add({severity:'success', summary:'Đã lưu', detail:`Đã thêm ${response.data.soDaThem} phân công; các phân công đã có được giữ nguyên`, life:3000});
      } catch (err) {
        toast.add({severity:'error', summary:'Không xác nhận được phân công', detail:err.response?.data || err.message || 'Vui lòng thử lại', life:5000});
      } finally { dangLuuCauHinh.value = false; }
    };

    let phienCauHinhThietBi = 0;
    const taiCauHinhThietBi = async () => {
      const phien = ++phienCauHinhThietBi;
      thietBiCauHinhIds.value = [];
      listThietBiTheoKhoa.value = [];
      nhomThietBiDaGan.value = [];
      listThietBiDichVu.value = [];
      const khoa = thietBiDichVu.value.idKhoaPhong;
      const nhom = thietBiDichVu.value.idNhomThietBi;
      if (!khoa || !nhom) return;
      try {
        const [thietBis, groups] = await Promise.all([
          benhNhanRepository.getThietBiTheoKhoa(khoa), benhNhanRepository.getNhomThietBiDichVu(khoa)
        ]);
        if (phien !== phienCauHinhThietBi) return;
        listThietBiTheoKhoa.value = thietBis.data.filter(x => x.idNhomThietBi === nhom);
        nhomThietBiDaGan.value = groups.data;
      } catch (err) {
        toast.add({severity:'error', summary:'Lỗi cấu hình thiết bị', detail:err.response?.data || 'Không tải được dữ liệu', life:3500});
      }
    };

    const ganThietBiHangLoat = async () => {
      if (dangLuuCauHinh.value || !thietBiDichVuIds.value.length) return;
      dangLuuCauHinh.value = true;
      try {
        const response = await benhNhanRepository.cauHinhHangLoat('thietBiDichVu', {
          idKhoaPhong:thietBiDichVu.value.idKhoaPhong, idNhomThietBi:thietBiDichVu.value.idNhomThietBi,
          dichVuIds:thietBiDichVuIds.value, thietBiIds:thietBiCauHinhIds.value, chonCaNhomThietBi:apCaNhomThietBi.value
        });
        await taiCauHinhThietBi();
        if (thietBiDichVuIds.value.length) {
          thietBiDichVu.value.idDichVu = thietBiDichVuIds.value[0];
          getListThietBiDichVu();
        }
        toast.add({severity:'success', summary:'Đã áp dụng', detail:`Đã thêm ${response.data.soDaThem} cấu hình mới`, life:2500});
      } catch (err) {
        toast.add({severity:'error', summary:'Không lưu được thiết bị dịch vụ', detail:err.response?.data || 'Vui lòng thử lại', life:3500});
      } finally { dangLuuCauHinh.value = false; }
    };

    const xoaApDungNhom = async (id: number) => {
      if (dangLuuCauHinh.value) return;
      dangLuuCauHinh.value = true;
      try { await benhNhanRepository.xoaNhomThietBiDichVu(id,khoaLamViec.value); await taiCauHinhThietBi(); }
      catch (err) { toast.add({severity:'error', summary:'Không bỏ được nhóm', detail:err.response?.data || 'Vui lòng thử lại', life:3500}); }
      finally { dangLuuCauHinh.value = false; }
    };

    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    const selectKhoaPhongChinh = (id) => {
      benhNhanRepository.getListNhanVienByIdKhoaPhong(id)
          .then((response) => {
           listNhanVienKhoaPhongById.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    }

    const selectKhoaPhongPhu = () => {
      benhNhanRepository.getListNhanVienByIdKhoaPhong(nhanVienThucHienPhu.value.idKhoaPhong)
          .then((response) => {
           listNhanVienKhoaPhongById.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    }

    const selectNhomThucHienDichVuChinh = () => {
      console.log("@@@@@#################### selectNhomThucHienDichVuChinh 111111");
      listNhanVienThucHienChinh.value = [];
      benhNhanRepository.getListNhanVienThucHien(nhanVienThucHienChinh.value.idNhomDichVu)
          .then((response) => {
           listNhanVienThucHien.value = response.data;
           listNhanVienThucHienChinh.value = listNhanVienThucHien.value.filter(x => x.chinh);
           //listNhanVienThucHienPhu.value = listNhanVienThucHien.value.filter(x => !x.chinh);
            if(listNhanVienThucHienChinh.value.length < 1){
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:'Không có nhân viên thủ thuật viên chính trong nhóm',
                life: 2500
              })
            }
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    }

    const selectNhomThucHienDichVuPhu = () => {
      listNhanVienThucHienPhu.value = [];
      benhNhanRepository.getListNhanVienThucHien(nhanVienThucHienPhu.value.idNhomDichVu)
          .then((response) => {
           listNhanVienThucHien.value = response.data;
           //listNhanVienThucHienChinh.value = listNhanVienThucHien.value.filter(x => x.chinh);
           listNhanVienThucHienPhu.value = listNhanVienThucHien.value.filter(x => !x.chinh);
           if(listNhanVienThucHienPhu.value.length < 1){
             toast.add({
               severity: 'error',
               summary: 'Lỗi',
               detail:'Không có nhân viên thủ thuật viên phụ trong nhóm',
               life: 2500
             })
           }
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    }

    const createNhanVienThucHienChinh = () => {
      console.log("@@@@@#################### createNhanVienThucHien 111111");
      nhanVienThucHienChinh.value.chinh = true;
      listNhanVienKhoaPhong.value.forEach(x => {
        if(x.nhanVien_Id == nhanVienThucHienChinh.value.idNhanVien)
          nhanVienThucHienChinh.value.tenNhanVien = x.tenNhanVien
      });
      if(nhanVienThucHienChinh.value.idNhanVien > 0 && nhanVienThucHienChinh.value.idKhoaPhong > 0&& nhanVienThucHienChinh.value.idNhomDichVu > 0) {
        benhNhanRepository.createNhanVienThucHien(nhanVienThucHienChinh.value)
            .then((response) => {
              selectNhomThucHienDichVuChinh();
              toast.add({
                severity: 'success',
                summary: 'Thành công',
                detail: 'Thêm nhân viên thành công vào nhóm',
                life: 2500
              })
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2500
              })
            });
      }
    }

    const createNhanVienThucHienPhu = () => {
      console.log("@@@@@#################### createNhanVienThucHien 222222");
      nhanVienThucHienPhu.value.chinh = false;
      listNhanVienKhoaPhong.value.forEach(x => {
        if(x.nhanVien_Id == nhanVienThucHienPhu.value.idNhanVien)
          nhanVienThucHienPhu.value.tenNhanVien = x.tenNhanVien
      });
      if(nhanVienThucHienPhu.value.idNhanVien > 0 && nhanVienThucHienPhu.value.idKhoaPhong > 0&& nhanVienThucHienPhu.value.idNhomDichVu > 0) {
        benhNhanRepository.createNhanVienThucHien(nhanVienThucHienPhu.value)
            .then((response) => {
              toast.add({
                severity: 'success',
                summary: 'Thành công',
                detail: 'Thêm nhân viên thành công vào nhóm',
                life: 2500
              })
              selectNhomThucHienDichVuPhu();
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2500
              })
            });
      }
    }

    const tenKhoaPhong = (st: any) => {
      console.log("@@@@@@@@@################ tenKhoaPhong st: " + st);
      const khoaPhong = ref("");
      listKhoaPhong.value.forEach(x => {
        if(st == x.phongBan_Id) {
          console.log("@@@@@@@@@################ tenKhoaPhong tenPhongBan: " + x.tenPhongBan);
          khoaPhong.value = x.tenPhongBan;
        }
      })
      return khoaPhong.value;
    }

    const tenNhomThucHienDV = (st: any) => {
      console.log("@@@@@@@@@################ tenNhomThucHienDV st: " + st);
      const nhom = ref("");
      listNhomThucHienDV.value.forEach(x => {
        if(st == x.id) {
          console.log("@@@@@@@@@################ tenNhomThucHienDV nhomThucHienDichVu: " + x.nhomThucHienDichVu);
          nhom.value =  x.nhomThucHienDichVu;
        }
      })

      console.log("@@@@@@@@@################ tenNhomThucHienDV abcd: ");
      return nhom.value;
    }

    const getListNhomThietBi = () => {
      const khoa=khoaLamViec.value;
      benhNhanRepository.getListNhomThietBi(khoa)
          .then((response) => {
            if(khoa!==khoaLamViec.value)return;
            listNhomThietBi.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    }

    const deleteNhomThietBi = (id: number) => {
      benhNhanRepository.deleteNhomThietBi(id,khoaLamViec.value)
          .then((response) => {
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    }


    const createNhomThietBi = () => {
      benhNhanRepository.createNhomThietBi({...nhomThietBi.value,idKhoaPhong:khoaLamViec.value})
          .then((response) => {
            getListNhomThietBi();
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    }

    getListNhomThietBi();

    const taiDanhMucThietBi = async () => {
      if (dangTaiDanhMucThietBi.value) return;
      dangTaiDanhMucThietBi.value = true;
      try {
        danhMucThietBi.value = (await benhNhanRepository.getDanhMucThietBi()).data;
        thietBiDaChon.value = [];
      } catch (err) {
        toast.add({severity: 'error', summary: 'Lỗi danh mục thiết bị', detail: err.response?.data || 'Không tải được thiết bị HIS', life: 3500});
      } finally {
        dangTaiDanhMucThietBi.value = false;
      }
    };

    let phienTaiThietBiKhoa = 0;
    const taiThietBiKhoa = async () => {
      const phien = ++phienTaiThietBiKhoa;
      const khoa = thietBi.value.idKhoaPhong;
      thietBiTrongKhoa.value = [];
      thietBiDaChon.value = [];
      if (!khoa) return;
      dangTaiThietBiKhoa.value = true;
      try {
        if (!danhMucThietBi.value.length) await taiDanhMucThietBi();
        const response = await benhNhanRepository.getThietBiTheoKhoa(khoa);
        if (phien === phienTaiThietBiKhoa) thietBiTrongKhoa.value = response.data;
      } catch (err) {
        if (phien === phienTaiThietBiKhoa)
          toast.add({severity: 'error', summary: 'Lỗi thiết bị khoa/phòng', detail: err.response?.data || 'Không tải được thiết bị trong khoa/phòng', life: 3500});
      } finally {
        if (phien === phienTaiThietBiKhoa) dangTaiThietBiKhoa.value = false;
      }
    };

    const ganThietBiVaoKhoa = async () => {
      if (dangGanThietBi.value || dangTaiThietBiKhoa.value || !thietBi.value.idKhoaPhong ||
          !thietBi.value.idNhomThietBi || !thietBiDaChon.value.length) return;
      dangGanThietBi.value = true;
      try {
        const response = await benhNhanRepository.ganThietBiVaoKhoa(thietBi.value.idKhoaPhong,
          thietBi.value.idNhomThietBi, thietBiDaChon.value.map(x => x.thietBi_Id));
        toast.add({severity: 'success', summary: 'Đã lưu', detail: `Đã thêm ${response.data.soThietBiDaThem} thiết bị vào khoa/phòng`, life: 2500});
        await taiThietBiKhoa();
      } catch (err) {
        toast.add({severity: 'error', summary: 'Không thêm được thiết bị', detail: err.response?.data || 'Vui lòng thử lại', life: 3500});
      } finally {
        dangGanThietBi.value = false;
      }
    };

    const getListThietBiTheoKhoa = (id: number, idKhoaPhong: number) => {
      benhNhanRepository.getListThietBi(id,khoaLamViec.value)
          .then((response) => {
            listThietBiTheoKhoa.value = response.data;
            listThietBiTheoKhoa.value = listThietBiTheoKhoa.value.filter(x => x.idKhoaPhong == idKhoaPhong);
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    }

    const getListThietBi = (id: number) => {
      benhNhanRepository.getListThietBi(id,khoaLamViec.value)
          .then((response) => {
            listThietBi.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    }

    const getListCaiDatDV = () => {
      benhNhanRepository.getListCaiDatDV()
          .then((response) => {
            listCaiDatDV.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    }

    getListCaiDatDV();


    

    const deleteThietBi = (id: number) => {
      benhNhanRepository.deleteThietBi(id,khoaLamViec.value)
          .then((response) => {
            taiThietBiKhoa();
            toast.add({
              severity: 'info',
              summary: 'Thành công',
              detail: 'Xóa thiết bị thành công',
              life: 2500
            })
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    }

    const createCaiDatThucHienDichVu = () => {
      if(caiDatChiDinhDV.value.soLuongThucHien < 1) caiDatChiDinhDV.value.soLuongThucHien = 1;
      listDichVu.value.filter(x => {
        if(x.dichVu_Id == caiDatChiDinhDV.value.dichVuId) caiDatChiDinhDV.value.tenDichVu = x.tenDichVu;
      })
      benhNhanRepository.createCaiDatChiTietThucHienDV(caiDatChiDinhDV.value)
          .then((response) => {
            getListCaiDatDV();
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Thêm cài đặt thực hiện dịch vụ thành công',
              life: 2500
            })
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    }

    const updateCaiDatThucHienDichVu = () => {
      if(caiDatChiDinhDV.value.soLuongThucHien < 1) caiDatChiDinhDV.value.soLuongThucHien = 1;
      listDichVu.value.filter(x => {
        if(x.dichVu_Id == caiDatChiDinhDV.value.dichVuId) caiDatChiDinhDV.value.tenDichVu = x.tenDichVu;
      })
      benhNhanRepository.updateCaiDatDV(caiDatChiDinhDV.value)
          .then((response) => {
            getListCaiDatDV();
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Thêm cài đặt thực hiện dịch vụ thành công',
              life: 2500
            })
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    }

    const deleteCaiDatDV = (id: number) => {
      confirm.require({
        group: 'templating',
        header: 'Xóa cài đặt',
        message: 'Xác nhận xóa cài đặt',
        icon: 'pi pi-exclamation-circle',
        acceptLabel: 'Xóa',
        rejectLabel: 'Hủy',
        accept: () => {
          // toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
          benhNhanRepository.deleteCaiDatDV(id)
              .then((response) => {
                getListCaiDatDV();
                toast.add({
                  severity: 'info',
                  summary: 'Thành công',
                  detail: 'Xóa cài đặt thành công',
                  life: 2500
                })
              })
              .catch(err => {
                toast.add({
                  severity: 'error',
                  summary: 'Lỗi',
                  detail:err.response.data,
                  life: 2500
                })});
        },
        reject: () => {
          // toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        }
      })
    }

    const deleteNhanVienKhoaPhong = (id: number) => {
      confirm.require({
        group: 'templating',
        header: 'Xóa nhân viên',
        message: 'Xác nhận xóa nhân viên khỏi khoa phòng',
        icon: 'pi pi-exclamation-circle',
        acceptLabel: 'Xóa',
        rejectLabel: 'Hủy',
        accept: () => {
          // toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
          benhNhanRepository.deteleNhanVienKhoaPhong(id,khoaLamViec.value)
              .then((response) => {
                getListDV();
                toast.add({
                  severity: 'info',
                  summary: 'Thành công',
                  detail: 'Xóa nhân viên thành công',
                  life: 2500
                })
              })
              .catch(err => {
                toast.add({
                  severity: 'error',
                  summary: 'Lỗi',
                  detail:err.response.data,
                  life: 2500
                })});
        },
        reject: () => {
          // toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        }
      })
    }

    const checkCD = ref(false);

    const checkCaiDatDV = (id: number) => {
      benhNhanRepository.checkCaiDatDV(id)
          .then((response) => {
            checkCD.value = response.data;
            console.log("$$$$$$##################### checkCD: " + checkCD.value);
            //const caiDat = ref({} as CaiDatChiTietThucHienDichVu);
            caiDatChiDinhDV.value.idNhomThietBi = 0;
            caiDatChiDinhDV.value.idNhomThucHien = 0;
            caiDatChiDinhDV.value.idNhomThucHienPhu = 0;
            caiDatChiDinhDV.value.soLuongThietBi = 0;
            caiDatChiDinhDV.value.soLuongThucHien = 0;
            if(checkCD.value){
              listCaiDatDV.value.forEach(x => {
                if(x.dichVuId == caiDatChiDinhDV.value.dichVuId)
                {
                  caiDatChiDinhDV.value.idNhomThietBi = x.idNhomThietBi;
                  caiDatChiDinhDV.value.idNhomThucHien = x.idNhomThucHien;
                  caiDatChiDinhDV.value.idNhomThucHienPhu = x.idNhomThucHienPhu;
                  caiDatChiDinhDV.value.soLuongThietBi = x.soLuongThietBi;
                  caiDatChiDinhDV.value.soLuongThucHien = x.soLuongThucHien;
                }
              })
            }
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    }

    const getTenNhomDV = (id: number) => {
      const name = ref("");
      console.log("$$$$$$##################### listNhomThucHienDV: " + JSON.stringify(listNhomThucHienDV.value));
      listNhomThucHienDV.value.forEach(x => {
        if(x.id == id) {
          console.log("$$$$$$##################### x.nhomThucHienDichVu: " + x.nhomThucHienDichVu);
          name.value = x.nhomThucHienDichVu;
        }
      });
      return name.value;
    }

    const getTenNhomThietBi = (id: number) => {
      const name = ref("");
      console.log("$$$$$$##################### listNhomThucHienDV: " + JSON.stringify(listNhomThucHienDV.value));
      listNhomThietBi.value.forEach(x => {
        if(x.id == id) {
          console.log("$$$$$$##################### x.nhomThucHienDichVu: " + x.tenNhomThietBi);
          name.value = x.tenNhomThietBi;
        }
      });
      return name.value;
    }

    const downloadFile = ref(false);
    const loadingBar = ref(false);
    const fileName = ref("");
    const loadingExport = ref(false);
    const date2 = ref();

    const formatDateTime = (date) => {
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format('HH:mm DD/MM/YYYY');
    };

    

    const formatHour = (value: string) => moment(value).format('HH:mm');

    const chiaGio = () => {
      if (!idKhoaPhongSelect.value || !date.value) {
        toast.add({severity: 'warn', summary: 'Thiếu thông tin', detail: 'Vui lòng chọn khoa/phòng và ngày thực hiện', life: 2500});
        return;
      }
      if (!chamCongDaLuu.value) {
        toast.add({severity: 'warn', summary: 'Chưa lưu chấm công', detail: 'Vui lòng lưu chấm công trước khi chia lịch', life: 2500});
        return;
      }
      if (!danhSachChamCong.value.some(x => x.coMat)) {
        toast.add({severity: 'warn', summary: 'Chưa có nhân viên có mặt', detail: 'Tất cả nhân viên đang được chấm vắng. Chọn Có mặt hoặc Tất cả có mặt, sau đó lưu chấm công.', life: 4000});
        return;
      }
      loadingExport.value = true;
      ketQuaChiaGio.value = null;
      benhNhanDangXem.value = '';
      hienTongHopBenhNhan.value=false;
      hienLichDaXep.value=false;
      hienLichChuaXep.value=false;
      hienLichNhanVien.value=false;
      benhNhanRepository.chiaGioThucHien(date.value.getTime() / 1000, idKhoaPhongSelect.value)
        .then(response => {
          ketQuaChiaGio.value = response.data;
          phienLichSu.value++;
          toast.add({severity: 'success', summary: 'Chia lịch thành công',
            detail: `Đã xếp ${response.data.daXepLich.length}/${response.data.tongChiDinh} chỉ định`, life: 2500});
        })
        .catch(err => toast.add({severity: 'error', summary: 'Lỗi', detail: err.response && err.response.data ? err.response.data : 'Không thể chia lịch', life: 3000}))
        .finally(() => loadingExport.value = false);
    }

    

    const mapName = (id) => {
      listNhanVienVltl.value.forEach(x => {
        if(x.userId == id)
        {
          return x.userName + " - " + x.userCode;
        }
      })
    }


    const showTemplate = (id) => {
      confirm.require({
        group: 'templating',
        header: 'Xóa thiết bị',
        message: 'Xác nhận xóa thiết bị',
        icon: 'pi pi-exclamation-circle',
        acceptLabel: 'Xóa',
        rejectLabel: 'Hủy',
        accept: () => {
          // toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
          deleteThietBi(id);
        },
        reject: () => {
          // toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        }
      });
    };

    const buoiChamCong = ref('caNgay');
    const doiChamCong = () => {
      danhSachChamCong.value.forEach(x=>x.coMat=x.coMatSang||x.coMatChieu);
      chamCongDaLuu.value = false;
      ketQuaChiaGio.value = null;
    };
    const chamCongTatCa = (coMat: boolean) => {
      danhSachChamCong.value.forEach(x => {
        if(buoiChamCong.value!=='chieu')x.coMatSang=coMat;
        if(buoiChamCong.value!=='sang')x.coMatChieu=coMat;
      });
      doiChamCong();
    };

    let phienChamCong=0;
    const loadChamCong = () => {
      const phien=++phienChamCong;
      const khoa=idKhoaPhongSelect.value;
      const time=date.value?.getTime();
      danhSachChamCong.value = [];
      ketQuaChiaGio.value = null;
      chamCongDaLuu.value = false;
      if (!khoa || !time) {loadingChamCong.value=false;return;}
      loadingChamCong.value = true;
      benhNhanRepository.getChamCongNhanVien(time / 1000,khoa)
          .then((response) => {
            if(phien!==phienChamCong||khoa!==idKhoaPhongSelect.value||time!==date.value?.getTime())return;
            danhSachChamCong.value = response.data.map(x=>({...x,coMatSang:x.coMatSang??x.coMat,coMatChieu:x.coMatChieu??x.coMat}));
            chamCongDaLuu.value = response.data.length > 0 && response.data.every(x => x.id > 0);
          })
          .catch(err => {
            if(phien!==phienChamCong)return;
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response && err.response.data ? err.response.data : 'Không tải được chấm công',
              life: 2500
            })})
          .finally(() => {if(phien===phienChamCong)loadingChamCong.value = false;});
    }

    const luuChamCong = () => {
      if (!idKhoaPhongSelect.value || !date.value || !danhSachChamCong.value.length) return;
      const khoa=idKhoaPhongSelect.value,time=date.value.getTime();
      const payload=danhSachChamCong.value.map(x=>({...x,coMat:x.coMatSang||x.coMatChieu}));
      loadingChamCong.value = true;
      benhNhanRepository.luuChamCongNhanVien(time / 1000,khoa,payload)
        .then(response => {
          if(khoa!==idKhoaPhongSelect.value||time!==date.value?.getTime())return;
          danhSachChamCong.value = response.data;
          chamCongDaLuu.value = true;
          toast.add({severity: 'success', summary: 'Đã lưu', detail: 'Đã lưu chấm công trong ngày', life: 2000});
        })
        .catch(err => toast.add({severity: 'error', summary: 'Lỗi', detail: err.response && err.response.data ? err.response.data : 'Không lưu được chấm công', life: 3000}))
        .finally(() => {if(khoa===idKhoaPhongSelect.value&&time===date.value?.getTime())loadingChamCong.value = false;});
    }

    const boDuyetDichVu = (dichVuId: number) => {
      const khoa = khoaLamViec.value;
      confirm.require({group:'templating', header:'Bỏ duyệt dịch vụ',
        message:'Bỏ dịch vụ khỏi danh sách được chia lịch của khoa/phòng này?', acceptLabel:'Bỏ duyệt', rejectLabel:'Hủy',
        accept:async () => {
          dangLuuDichVu.value = true;
          try {
            await benhNhanRepository.boDuyetDichVuKhoa(khoa, dichVuId);
            await taiDichVuKhoa();
            locDichVuTheoNhom();
            ketQuaChiaGio.value = null;
            chinhDichVuIds.value = []; phuDichVuIds.value = []; thietBiDichVuIds.value = [];
          } catch (err) {
            toast.add({severity:'error', summary:'Không bỏ duyệt được', detail:err.response?.data || 'Vui lòng thử lại', life:3500});
          } finally { dangLuuDichVu.value = false; }
        }
      });
    };

    const dangXoaTatCa = ref(false);
    const xacNhanXoaTatCa = (loai: string) => {
      const khoa = khoaLamViec.value;
      if (!khoa || dangXoaTatCa.value || dangLuuCauHinh.value || dangLuuDichVu.value) return;
      const moTa: Record<string,string> = {
        dichVu:'toàn bộ dịch vụ đã duyệt và các phân công chính/phụ, gán thiết bị vào dịch vụ liên quan',
        nhanVien:'toàn bộ nhân viên khỏi khoa và phân công chính/phụ của khoa. Lịch sử chấm công được giữ lại',
        thietBi:'toàn bộ thiết bị đã thêm vào khoa và các gán thiết bị/nhóm thiết bị vào dịch vụ của khoa',
        chinh:'toàn bộ phân công thủ thuật viên chính của khoa, bao gồm quyền chính từ nhóm dịch vụ và nhân viên ngoài bộ lọc đang xem',
        phu:'toàn bộ phân công thủ thuật viên phụ của khoa, bao gồm quyền phụ từ nhóm dịch vụ và nhân viên ngoài bộ lọc đang xem',
        thietBiDichVu:'toàn bộ gán thiết bị và nhóm thiết bị vào dịch vụ của khoa; thiết bị trong khoa được giữ lại'
      };
      if (!moTa[loai]) return;
      const tenKhoa = tenKhoaLamViec.value;
      confirm.require({group:'templating', header:'Xác nhận xóa tất cả', icon:'pi pi-exclamation-triangle',
        message:`Bạn có chắc muốn xóa ${moTa[loai]} tại ${tenKhoa} (mã ${khoa})? Thao tác áp dụng cho tất cả các trang và không thể hoàn tác.`,
        acceptLabel:'Xác nhận xóa tất cả', rejectLabel:'Hủy', acceptClass:'p-button-danger', defaultFocus:'reject',
        accept:async () => {
          if (dangXoaTatCa.value || khoa !== khoaLamViec.value) return;
          dangXoaTatCa.value=true;
          dangLuuCauHinh.value=true;
          dangLuuDichVu.value=true;
          let daXoa=false;
          try {
            const response=await benhNhanRepository.xoaTatCaCauHinh(khoa,loai);
            daXoa=true;
            if (khoa !== khoaLamViec.value) return;
            ketQuaChiaGio.value=null;
            if (loai==='dichVu') {
              chinhDichVuIds.value=[]; phuDichVuIds.value=[]; thietBiDichVuIds.value=[];
              dichVuDaChon.value=[]; chonTatCaDichVu.value=false;
              await taiDichVuKhoa(); locDichVuTheoNhom();
            }
            if (loai==='nhanVien') {
              nhanVienKhoaIds.value=[]; chinhNhanVienIds.value=[]; phuNhanVienIds.value=[];
              listNhanVienKhoaPhong.value=[]; listNhanVienKhoaPhongByIdChinh.value=[]; listNhanVienKhoaPhongByIdPhu.value=[];
              danhSachChamCong.value=[]; chamCongDaLuu.value=false;
            }
            nguoiThucHienChinh.value.idNguoiThucHien=0; nguoiThucHienPhu.value.idNguoiThucHien=0;
            if (loai==='chinh') { chinhNhanVienIds.value=[]; chinhDichVuIds.value=[]; }
            if (loai==='phu') { phuNhanVienIds.value=[]; phuDichVuIds.value=[]; }
            await getListNguoiThucHien();
            if (nhomDichVuNoiBoRef.value) await nhomDichVuNoiBoRef.value.tai();
            if (khoa !== khoaLamViec.value) return;
            if (loai==='thietBi' || loai==='thietBiDichVu' || loai==='dichVu') {
              thietBiCauHinhIds.value=[]; thietBiDichVuIds.value=[]; thietBiDaChon.value=[];
              await taiThietBiKhoa(); await taiCauHinhThietBi();
            }
            toast.add({severity:'success',summary:'Đã xóa cài đặt',detail:`Đã xóa ${response.data.soDaXoa} bản ghi tại ${tenKhoa}.`,life:4000});
          } catch (err) {
            toast.add({severity:'error',summary:daXoa ? 'Đã xóa, cần tải lại dữ liệu' : 'Không xóa được cài đặt',
              detail:err.response?.data || 'Vui lòng tải lại trang để kiểm tra',life:5000});
          } finally { dangXoaTatCa.value=false; dangLuuCauHinh.value=false; dangLuuDichVu.value=false; }
        }
      });
    };

    const xuatExcelKetQua = async () => {
      const snapshot=ketQuaChiaGio.value;
      if (!snapshot || dangXuatExcel.value) return;
      dangXuatExcel.value=true;
      try {
        const response=await benhNhanRepository.xuatExcelChiaGio(snapshot);
        const url=window.URL.createObjectURL(response.data);
        const link=document.createElement('a');
        link.href=url;
        link.download=`ChiaGio_Khoa${snapshot.khoaPhongId}_${moment(snapshot.ngayThucHien).format('YYYYMMDD')}.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        phienLichSu.value++;
        window.setTimeout(() => window.URL.revokeObjectURL(url),1000);
      } catch (err) {
        const message=err.response?.data instanceof Blob ? await err.response.data.text() : err.response?.data;
        toast.add({severity:'error',summary:'Không xuất được Excel',detail:typeof message==='string' ? message.slice(0,350) : 'Vui lòng thử lại',life:4000});
      } finally { dangXuatExcel.value=false; }
    };

    let phienKhoaLamViec = 0;
    watch(khoaLamViec, async khoa => {
      const phien = ++phienKhoaLamViec;
      nhanVienKhoaPhong.value.idKhoaPhong = khoa;
      thietBi.value.idKhoaPhong = khoa;
      thietBiDichVu.value.idKhoaPhong = khoa;
      idKhoaPhongChinh.value = khoa;
      idKhoaPhongPhu.value = khoa;
      idKhoaPhongSelect.value = khoa;
      nhanVienKhoaIds.value = []; chinhNhanVienIds.value = []; phuNhanVienIds.value = [];
      chinhDichVuIds.value = []; phuDichVuIds.value = []; thietBiDichVuIds.value = [];
      thietBiCauHinhIds.value = []; thietBiDaChon.value = []; dichVuDaChon.value = [];
      chonTatCaDichVu.value = false; nhomDichVuDangMo.value = []; nhomDichVuSelect.value = 0;
      listDichVuTheoNhom.value = []; listNhanVienKhoaPhong.value = [];
      listNhanVienKhoaPhongByIdChinh.value = []; listNhanVienKhoaPhongByIdPhu.value = [];
      listNguoiThucHienChinh.value = []; listNguoiThucHienPhu.value = [];
      nguoiThucHienChinh.value.idNguoiThucHien = 0; nguoiThucHienPhu.value.idNguoiThucHien = 0;
      ketQuaChiaGio.value = null; danhSachChamCong.value = []; chamCongDaLuu.value = false;
      thietBiTrongKhoa.value = []; listThietBiDichVu.value = []; nhomThietBiDaGan.value = [];
      listNhomThietBi.value=[];thietBiDichVu.value.idNhomThietBi=0;
      if (!khoa) { await taiDichVuKhoa(); return; }
      try {
        const [_, staff] = await Promise.all([taiDichVuKhoa(), benhNhanRepository.getListNhanVienByIdKhoaPhong(khoa)]);
        if (phien !== phienKhoaLamViec) return;
        listNhanVienKhoaPhong.value = staff.data.map(x => ({...x, khoaPhong:tenKhoaLamViec.value}));
        listNhanVienKhoaPhongByIdChinh.value = staff.data;
        listNhanVienKhoaPhongByIdPhu.value = staff.data;
        await getListNguoiThucHien();
        getListNhomThietBi();
        if (buocDangMo.value === 0) await taiDanhMucDuyet();
        if (phien !== phienKhoaLamViec) return;
        locDichVuTheoNhom();
        if (date.value) loadChamCong();
        taiThietBiKhoa();
        taiCauHinhThietBi();
      } catch (err) {
        if (phien === phienKhoaLamViec)
          toast.add({severity:'error', summary:'Không tải được dữ liệu khoa/phòng', detail:err.response?.data || 'Vui lòng thử lại', life:3500});
      }
    });
    watch(buocDangMo, index => { if (index === 0) taiDanhMucDuyet(); if (index === 3) getListNguoiThucHien(); });
    watch(date,()=>loadChamCong());

    return {
      hienLichNhanVien,hienLichSu,soNhanVienTrongLich,
      thoiGianUtc,
      lichSuRef,phienLichSu,moLichSuChiaGio,ngayLichSuDangXem,
      buoiChamCong,doiChamCong,
      nhomDichVuNoiBoRef,
      dangXoaTatCa, xacNhanXoaTatCa,
      hienTongHopBenhNhan, hienLichDaXep, hienLichChuaXep, dangXuatExcel, xemDichVuBenhNhan, xuatExcelKetQua,
      khoaLamViec, tenKhoaLamViec, buocDangMo, dangTaiDichVuKhoa, dangTaiDanhMucDuyet, boDuyetDichVu,
      benhNhanDangXem, lichDangXem, chuaXepDangXem,
      nhanVienKhoaIds, chinhNhanVienIds, phuNhanVienIds, chinhDichVuIds, phuDichVuIds,
      thietBiCauHinhIds, thietBiDichVuIds, apCaNhomThietBi, nhomThietBiDaGan, dangLuuCauHinh,
      themNhanVienHangLoat, ganNhanVienHangLoat, taiCauHinhThietBi, ganThietBiHangLoat, xoaApDungNhom,
      date,
      service,
      kind,
      status,
      showScreenChoice,
      listNhanVienVltl,
      idNhanVien,
      listDichVu,
      listDichVuAll,
      listNhomDichVu,
      nhomDichVuSelect,
      listDichVuTheoNhom,
      dichVuDaChon,
      boLocDichVuChon,
      locDichVuTheoNhom,
      chonCaNhom,
      boChonTatCa,
      chonTatCaDichVu,
      soDichVuDaChon,
      dongChonTatCa,
      bangDichVu,
      nhomDichVuDangMo,
      moNhomDichVu,
      dangLuuDichVu,
      createNhieuDichVu,
      updateDichVu,
      clearFilter,
      filters,
      dichVu,

      listNhomThucHienDV,
      nhomThucHien,
      createNhomDichVu,
      listKhoaPhong,
      nhanVienKhoaPhong,
      listNhanVienKhoaPhong,
      idKhoaPhong,
      listNhanVienKhoaPhongById,
      selectKhoaPhongChinh,
      selectKhoaPhongPhu,
      idNhanVienSelect,
      idNhomThucHienDV,
      nhanVienThucHienChinh,
      nhanVienThucHienPhu,
      createNhanVienThucHienChinh,
      selectNhomThucHienDichVuChinh,
      selectNhomThucHienDichVuPhu,
      listNhanVienThucHien,
      listNhanVienThucHienChinh,
      listNhanVienThucHienPhu,
      tenKhoaPhong,
      tenNhomThucHienDV,
      createNhanVienThucHienPhu,
      nhomThietBi,
      thietBi,
      taiDanhMucThietBi,
      taiThietBiKhoa,
      ganThietBiVaoKhoa,
      thietBiChuaGan,
      thietBiTrongKhoa,
      thietBiDaChon,
      boLocThietBiHis,
      dangTaiDanhMucThietBi,
      dangTaiThietBiKhoa,
      dangGanThietBi,
      createNhomThietBi,
      getListNhomThietBi,
      deleteNhomThietBi,
      getListThietBi,
      deleteThietBi,
      listThietBi,
      listNhomThietBi,
      createCaiDatThucHienDichVu,
      caiDatChiDinhDV,
      listCaiDatDV,
      getTenNhomDV,
      idKhoaPhongSelect,
      loadingExport,
      downloadFile,
      loadingBar,
      deleteCaiDatDV,
      checkCaiDatDV,
      checkCD,
      getTenNhomThietBi,
      updateCaiDatThucHienDichVu,
      mapName,
      showTemplate,
      deleteNhanVienKhoaPhong,
      idKhoaPhongChinh,
      idKhoaPhongPhu,
      nguoiThucHienChinh,
      nguoiThucHienPhu,
      getListNguoiThucHien,
      listNguoiThucHienChinh,
      listNguoiThucHienPhu,
      deleteDichVuThucHien,
      listNhanVienKhoaPhongByIdChinh,
      listNhanVienKhoaPhongByIdPhu,
      selectKhoaPhong,
      getListThietBiTheoKhoa,
      idNhomThietBi,
      idKhoaPhongThietBi,
      thietBiDichVu,
      listThietBiTheoKhoa,
      getListThietBiDichVu,
      listThietBiDichVu,
      deleteThietBiDichVu,
      isLoggedIn,
      loadChamCong,
      chamCongTatCa,
      luuChamCong,
      danhSachChamCong,
      chamCongDaLuu,
      loadingChamCong,
      nhanVienHoatDong
      ,ketQuaChiaGio
      ,chiaGio
      ,formatHour
    }
  }

}
